var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['select-wrapper', {error: _vm.error }]},[_c('input',{attrs:{"type":_vm.inputtype,"placeholder":_vm.placeholdertext},domProps:{"value":_vm.value},on:{"input":_vm.update}})])}
var staticRenderFns = []

export { render, staticRenderFns }